import { useQuery } from '@apollo/client'
import { Button, useMediaQuery, useTheme } from '@material-ui/core'
import { useState } from 'react'
import { useParams } from 'react-router-dom'

import SectionTitle from '../../components/SectionTitle'
import { RATEPLAN_POLICY_QUERY } from '../../graphql/ratePlanPolicies'
import { getRoleFromStorage } from '../../helpers/userData'
import { getTranslate } from '../../localization'
import ratePlanPagesRoleManagement from '../../staticRoleManagement/ratePlanRoleManagement'
import { RatePlanPolicy } from '../../types/rateplanPolicy'
import RatePlansAddPoliciesModal from './RatePlansAddPoliciesModal'
import RatePlansPoliciesList from './RatePlansPoliciesList'
import RatePlansPoliciesListMobile from './RatePlansPoliciesListMobile'
import useStyles from './styles/index.styles'

interface RatePlansPoliciesProps {
  providerCode: string
}
const RatePlansPolicies: React.FC<RatePlansPoliciesProps> = ({
  providerCode
}) => {
  const theme = useTheme()
  const classes = useStyles()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))
  const params = useParams<{
    accommodationID: string
    roomTypeID: string
    id: string
  }>()

  const { loading, data, refetch } = useQuery<{
    ratePlanPolicies: RatePlanPolicy[]
  }>(RATEPLAN_POLICY_QUERY, {
    notifyOnNetworkStatusChange: true,
    variables: {
      accID: params.accommodationID,
      roomTypeID: params.roomTypeID,
      ratePlanID: params.id
    }
  })

  const [addPoliciesModalIsOpen, setaddPoliciesModalIsOpen] =
    useState<boolean>(false)

  const hasAccessToWriteRatePlanPolicies = ratePlanPagesRoleManagement
    .find(
      (item) =>
        item.route ===
        '/accommodations/:accommodationID/:propertyCode/room-type/:roomTypeID/rate-plans/:id/providerCode/:providerCode/:page'
    )
    ?.tabs?.find((tabItem) => tabItem.params.page === 'policies')
    ?.rolesListWithWriteAccess?.includes(getRoleFromStorage())
  return (
    <div>
      <div className={classes.header}>
        <SectionTitle title="Policies" marginBottom />
        {hasAccessToWriteRatePlanPolicies && (
          <Button
            variant="contained"
            color="primary"
            onClick={() => setaddPoliciesModalIsOpen(true)}>
            {getTranslate('Add Policies')}
          </Button>
        )}
      </div>
      <div>
        {isSmallScreen ? (
          <RatePlansPoliciesListMobile
            data={data?.ratePlanPolicies}
            loading={loading}
            reloadData={refetch}
          />
        ) : (
          <RatePlansPoliciesList
            data={data?.ratePlanPolicies}
            loading={loading}
            reloadData={refetch}
          />
        )}
        <div>
          <RatePlansAddPoliciesModal
            isOpen={addPoliciesModalIsOpen}
            onClose={() => setaddPoliciesModalIsOpen(false)}
            providerCode={providerCode}
            refetch={refetch}
          />
        </div>
      </div>
    </div>
  )
}
export default RatePlansPolicies
